

export const keyswordsBack = `driver license not for real purposes dl none driver's drivers fecha col bogota d.c barranquilla cundinamarca ene feb mar abr may jun jul ago sep oct nov dic nacimiento lugar expedición registrador registra nacional indice derecho documento DOCUMENTO INCLUSIÓN INCLUSION inclusion`
export const keyswordsFront = `class comb single end none restr visit callers please dial you move within days col cedula cédula extranjeria extranjería migrante vence identificacion identificación numero personal colombia cedula de ciudadania republica de colombia nombres apellidos nuip apellidos fecha de nacimiento firma estatura sexo nacimiento lugar`

export const EVENT_TRACER = {
    SERVICE: {
        InitServiceLiveness: 'InitServiceLiveness',
        InitServiceCardCapture: 'InitServiceCardCapture',
        InitConfigCamera: 'InitConfigCamera',
        InitValidationCameraVirtual: 'InitValidationCameraVirtual',
        EndValidationCameraVirtual: 'EndValidationCameraVirtual',
        InitGetBestCamera: 'InitGetBestCamera',
        EndGetBestCamera: 'EndGetBestCamera',
        SelectedBestCamera: 'SelectedBestCamera',
        InitConfigValues: 'InitConfigValues',
        EndConfigValues: 'EndConfigValues',
        InitShowGuide: 'InitShowGuide',
        EndShowGuide: 'EndShowGuide',
        InitStartDetection: 'InitStartDetection',
        EndStartDetection: 'EndStartDetection',
        InitDetection: 'InitDetection',
        EndDetection: 'EndDetection',
        CreateBase64Image: 'CreateBase64Image',
        Base64ImageCreated: 'Base64ImageCreated',
        SignImage: 'SignImage',
        ImageSigned: 'ImageSigned',
        InitValidateSignature: 'InitValidateSignature',
        EndValidateSignature: 'EndValidateSignature',
        FailedValidateSignature: 'FailedValidateSignature',
        SendingImageToValidate: 'SendingImageToValidate',
        SendingImageToValidateFinish: 'SendingImageToValidateFinish',
        CapturedImage: 'CapturedImage',
    },
    LIVENESS: {
        LivenessCameraOpen: 'LivenessCameraOpen',
        LivenessCameraError: 'LivenessCameraError',
        LivenessTimeout: 'LivenessTimeout',
        LivenessInitCaptureVideo: 'LivenessInitCaptureVideo',
        LivenessFinishCaptureVideo: 'LivenessFinishCaptureVideo',
        LivenessCaptureSuccess: 'LivenessCaptureSuccess',
        LivenessResponseToHost: 'LivenessResponseToHost',

        // nuevos eventos
    },
    CARD_CAPTURE: {
        CardCaptureCameraOpen: 'CardCaptureCameraOpen',
        CardCaptureCameraError: 'CardCaptureCameraError',
        CardCaptureInitCaptureManual: 'CardCaptureInitCaptureManual',
        CardCaptureTakePhoToManual: 'CardCaptureTakePhotoManual',
        CardCaptureResponseToHost: 'CardCaptureResponseToHost'
    }
}
